import type { MaskEmail } from './types';

export const maskEmail: MaskEmail = (email) => {
  const [localPart, domain] = email.split('@');

  if (!localPart || !domain) {
    return email;
  }

  if (localPart.length <= 3) {
    return `${localPart}***@${domain}`;
  }

  const firstThreeChars = localPart.slice(0, 3);
  const maskedPortion = '*'.repeat(localPart.length - 3);

  return `${firstThreeChars}${maskedPortion}@${domain}`;
};
